<template>
  <div>
    <el-upload
      class="avatar-uploader"
      action=""
      :show-file-list="false"
      :auto-upload="false"
      :on-change="uploadChange"
    >
      <i class="el-icon-plus avatar-uploader-icon" />
    </el-upload>
    <span style="margin-left: 10px">数量：{{ imageList.length }}/10</span>
    <el-button type="primary" class="fr" @click="addInput">添加</el-button>
    <el-card v-if="imageList.length" style="max-height: 300px;overflow: auto;">
      <div
        v-for="(item, index) in imageList"
        :key="index"
        class="input-item"
      >
        <img v-if="item.id" :src="item.url" class="avatar">
        <i
          class="el-icon-remove input-list-icon"
          style="color: red"
          @click="removeInput(index)"
        />
      </div>
    </el-card>

  </div>
</template>

<script>
import MaterialResource from '@/api/material/jrtt';
const materialResource = new MaterialResource();

export default {
  props: {
    advertiserId: {
      type: [Number, String],
      required: true,
    },
    /** 值 */
    imageList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /** 输入框宽度 */
    width: {
      type: String,
      default: '250px',
    },
    /** 最大数量 */
    maxCount: {
      type: Number,
      default: 10,
    },
  },
  data(){
    return {
      temp_value: '',
    };
  },
  created() {
  },
  methods: {
    // 上传变化事件
    uploadChange: function(file) {
      const temp_url = URL.createObjectURL(file.raw);
      const temp_img = new Image();
      const is_type = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const is_len = file.raw.size / 1024 / 1024 < 1;

      if (!is_type) {
        this.$message.error('上传头像图片只能是 JPG和PNG 格式!');
        return;
      }
      if (!is_len) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
        return;
      }

      temp_img.src = temp_url;

      const formData = new FormData();
      temp_img.onload = () => {
        const is_size = temp_img.width === 108 && temp_img.height === 108;
        if (!is_size) {
          this.$message.error('上传文件格式大小不符合要求，原因：卡片图片宽度必须108像素；卡片图片高度必须108像素');
        }

        if (is_size) {
          formData.append('advertiser_id', this.advertiserId);
          formData.append('image', file.raw);
          formData.append('thumb_width', temp_img.width);
          formData.append('thumb_height', temp_img.height);
          this.uploadingPic(formData).then((img_res) => {
            this.imageList.push({
              id: img_res.id,
              url: temp_url,
            });
          });
        }
      };
    },

    // 添加输入框
    addInput() {
      if (this.temp_value) {
        if (this.imageList.length < this.maxCount) {
          this.imageList.push(this.temp_value);
          this.temp_value = '';
        } else {
          this.$message.warning(`上限为${this.maxCount}个`);
        }
      } else {
        this.$message.warning('输入框不能为空');
      }
    },

    /**
     * 移除输入框
     * @param {number} index 索引值
     */
    removeInput(index) {
      if (this.imageList.length !== 0) {
        this.imageList.splice(index, 1);
      } else {
        this.$message.warning('至少保留一个');
      }
    },

    // 上传图片素材
    uploadingPic(params) {
      return new Promise((resolve, reject) => {
        materialResource
          .uploadingPicApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
</script>

  <style lang="scss" scoped>
   $upload-border-size: 108px;

  .input-item {
      padding-bottom: 10px;
  }
  .input-list-icon {
      margin-left: 10px;
      font-size: 20px;
      vertical-align: middle;
      cursor: pointer;
      float: right;
  }
  .avatar {
    width: $upload-border-size;
    height: $upload-border-size;
    display: block;
  }

  </style>

